import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { State, Mutation } from "vuex-class";
let SysContentHeader = class SysContentHeader extends Vue {
    constructor() {
        super(...arguments);
        this.win = window;
        this.tagList = [{ name: "用户管理" }];
    }
    handleClose(item, index) {
        if (item.url != this.$route.path) {
            this.UP_GOROUTER(index);
        }
        else {
            let url = "";
            if (this.sys.goRouter[index + 1]) {
                url = this.sys.goRouter[index + 1].url;
            }
            else {
                url = this.sys.goRouter[index - 1].url;
            }
            this.UP_GOROUTER(index);
            this.$router.push(url);
        }
    }
    tagClick(item) {
        this.$router.push(item.url);
    }
    routerClick(item) {
        this.$router.push(item.fullPath);
    }
    goBack() {
        this.win.history.go(-1);
    }
};
__decorate([
    State("sys")
], SysContentHeader.prototype, "sys", void 0);
__decorate([
    Mutation("UP_GOROUTER")
], SysContentHeader.prototype, "UP_GOROUTER", void 0);
SysContentHeader = __decorate([
    Component
], SysContentHeader);
export default SysContentHeader;
